import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import i18n from '../../i18n';
import Layout from '../../components/Layout';
import InnerUserForm from '../../components/User/Form';
import Toolbar from "../../components/Toolbar/Toolbar";

const UserForm = ({classes, canEditRoles, roles, user}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('user.title')}
        />

        <div className={classes.layout}>
            <Paper className={classes.paper}>
                {user ? (
                    /* Edit a already existing user */
                    <InnerUserForm
                        method="PUT"
                        url={`/users/${user.id}`}
                        canEditRoles={canEditRoles}
                        roles={roles}
                        values={user}
                        isEdit={true}
                    />
                ) : (
                    /* Create a new user */
                    <InnerUserForm
                        method="POST"
                        url="/users"
                        roles={roles}
                        isEdit={false}
                    />
                )}
            </Paper>
        </div>
    </Layout>
);

const styles = theme => ({
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(UserForm);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/user/Form.jsx